import gql from 'graphql-tag'
import { connect } from 'react-redux'
import { compose, withState } from 'recompose'

import { makesQueries, dataFetched } from 'data/graphql'

export const query = gql`
  query FetchPublicNote($token: ID!) {
    showPublicNote(token: $token) {
      id
      __typename
      title
      otType
      publicShareToken
      publiclySharedAt
      publiclySharedBy
      madePubliclyEditableAt
      madePubliclyEditableBy
    }
  }
`

export default () =>
  compose(
    connect(
      null,
      {
        dataFetched,
      }
    ),
    withState('error', 'setError', null),
    makesQueries({
      query,
      mapPropsToVariables: ({ token }) => ({ token }),
      getOnResultFromProps: ({ dataFetched }) => ({ result }) => {
        dataFetched(result.data.showPublicNote)
      },
      getOnErrorFromProps: ({ setError }) => ({ error }) => {
        setError(error)
      },
    })
  )
